import { atom } from "jotai";

import { locationModalAtom } from "./state";

export const isVisibleAtom = atom(
  (get) => get(locationModalAtom).isVisible,
  (_get, set, value: boolean) => {
    set(locationModalAtom, (draft) => {
      draft.isVisible = value;
    });
  },
);

export const contactIdAtom = atom((get) => get(locationModalAtom).contactId);

export const showAtom = atom(
  null,
  (_get, set, contactId: number | null = null) => {
    set(locationModalAtom, (draft) => {
      draft.isVisible = true;
      draft.contactId = contactId;
    });
  },
);

export const hideAtom = atom(null, (_get, set) => {
  set(isVisibleAtom, false);
});
